import { render, staticRenderFns } from "./WelcomeNotice.vue?vue&type=template&id=1377446e&scoped=true"
import script from "./WelcomeNotice.vue?vue&type=script&lang=js"
export * from "./WelcomeNotice.vue?vue&type=script&lang=js"
import style0 from "./WelcomeNotice.vue?vue&type=style&index=0&id=1377446e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1377446e",
  null
  
)

export default component.exports